import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner'; // Assuming a loading spinner component exists
import { isAccountSuspended, isActiveAdmin } from '../../utils/accessControl';

const AdminRouteGuard: React.FC = () => {
  const {
    currentUser,
    userProfile,
    claims,
    loading,
    claimsLoading,
    adminAccessResolving,
    refreshClaims,
  } = useAuth();
  const [routeRefreshDone, setRouteRefreshDone] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (!currentUser) {
      setRouteRefreshDone(true);
      return () => {
        cancelled = true;
      };
    }

    setRouteRefreshDone(false);
    refreshClaims(true)
      .catch((error) => {
        console.warn('[AdminRouteGuard] Failed to refresh claims for route check:', error);
      })
      .finally(() => {
        if (!cancelled) {
          setRouteRefreshDone(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [currentUser, refreshClaims]);

  if (loading || claimsLoading || adminAccessResolving || !routeRefreshDone) {
    // Show a loading indicator while checking auth and profile
    return <LoadingSpinner />;
  }

  if (!currentUser) {
    // If not logged in, redirect to login page
    console.log('AdminRouteGuard: No user logged in, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  if (isAccountSuspended(userProfile, claims)) {
    console.warn('AdminRouteGuard: Suspended account detected. Redirecting to /app.');
    return <Navigate to="/app" replace />;
  }

  if (!isActiveAdmin(userProfile, claims)) {
    // If logged in but not an admin, redirect to home page
    console.log('AdminRouteGuard: Active admin capability is unavailable, redirecting to /');
    return <Navigate to="/" replace />;
  }

  // If logged in and is an admin, render the nested routes
  console.log('AdminRouteGuard: User is admin, allowing access.');
  return <Outlet />;
};

export default AdminRouteGuard;
